import { roundTo } from '../../helpers/validators/validate.js';
import { formatNumberForLocale } from '../../helpers/helpers.js';
export function renderKPIS(ix, assetKPIs, currency) {

    var old = $("#visualization_"+ix).parent().find(".kpi-content");

    $(old).each(function() {
        $(this).remove();
    })

    var isin_wkn_string = "";
    if (userassets[ix]['isin'] || userassets[ix]['wkn']){
        isin_wkn_string = '(<small>ISIN: '+ userassets[ix]['isin'] +' WKN: '+userassets[ix]['wkn']+'</small>)';
    } 
    

    var data = {
        currency: currency,
        name: userassets[ix]['name'],
        f52_high: assetKPIs['fiftyTwoWeekHigh'] ? formatNumberForLocale(roundTo(assetKPIs['fiftyTwoWeekHigh'], 2)) : "-",
        t52_high: assetKPIs['high52wDate'] ? new Date(assetKPIs['high52wDate'])
            .toLocaleDateString(window.navigator.language, 
            {
			    year: 'numeric',
			    month: 'long',
			    day: 'numeric'  }) : "-", 
        diff52_high: assetKPIs['fiftyTwoWeekHigh'] ? (assetKPIs['lastPrice'] ? (calculateHighDiff(assetKPIs['fiftyTwoWeekHigh'], assetKPIs['lastPrice'])) : "-") : "-"
        
        ,

        f52_low: assetKPIs['fiftyTwoWeekLow'] ? formatNumberForLocale(roundTo(assetKPIs['fiftyTwoWeekLow'], 2)) : "-",
        t52_low: assetKPIs['low52wDate'] ? new Date(assetKPIs['low52wDate'])
            .toLocaleDateString(window.navigator.language, 
            {
			    year: 'numeric',
			    month: 'long',
			    day: 'numeric',   }) : "-", 
        diff52_low: assetKPIs['fiftyTwoWeekLow'] ? (assetKPIs['lastPrice'] ? (calculateHighDiff(assetKPIs['fiftyTwoWeekLow'], assetKPIs['lastPrice'])) : "-") : "-",

        f50_avg: assetKPIs['fiftyDayAverage'] ? formatNumberForLocale(roundTo(assetKPIs['fiftyDayAverage'], 2)) : "-",
        f200_avg: assetKPIs['twoHundredDayAverage'] ? formatNumberForLocale(roundTo(assetKPIs['twoHundredDayAverage'], 2)) : "-",
        isin_wkn: isin_wkn_string
    }

    

    var rowTemplate = _.template(template_aasset_kpis);
    var compiledTemplate = rowTemplate({ data: data });
    var html = $.parseHTML(compiledTemplate);
    
    $(html).insertAfter("#visualization_"+ix);

    function calculateHighDiff(highValue, lastPrice) {
        if (!highValue || !lastPrice) {
            return "-";
        }

        var high = parseFloat(highValue);
        var last = parseFloat(lastPrice);

        if (!isFinite(high) || high === 0 || !isFinite(last)) {
            return "-";
        }

        var diffPercent = ((last - high) / high) * 100;
        var rounded = formatNumberForLocale(roundTo(diffPercent, 2));
        return (diffPercent > 0 ? "+" : "") + rounded + "%";
    }

}